import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  projectCrowdsaleStatus: string | null
}

const ProjectCrowdsaleStatusChip: React.FC<ComponentProps> = ({ projectCrowdsaleStatus }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (projectCrowdsaleStatus === 'PENDING') {
    color = 'primary'
    variant = 'outlined'
  } else if (projectCrowdsaleStatus === 'AVAILABLE') {
    color = 'success'
    variant = 'outlined'
  } else if (projectCrowdsaleStatus === 'COMPLETED') {
    variant = 'outlined'
  }

  return (
    <>
      {projectCrowdsaleStatus === null
        ? (
          <></>
          )
        : (
          <Tooltip title={projectCrowdsaleStatus} TransitionComponent={Zoom} arrow placement='bottom'>
            <Chip label={projectCrowdsaleStatus} variant={variant} color={color} />
          </Tooltip>
          )
      }
    </>
  )
}

export default ProjectCrowdsaleStatusChip
